import { cx } from '@emotion/css'
import { AppState, capitalize, ScriptLoadResult } from '@news-mono/web-common'
import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import { TaboolaProps } from './Taboola'
import { TaboolaContext } from './TaboolaScriptProvider'

export const Taboola: React.FC<TaboolaProps> = ({
    articleId,
    locationType,
    taboolaContainerId,
}) => {
    const { result } = useContext(TaboolaContext)
    const renditionType = useSelector(
        (state: AppState) => state.render.renditionType,
    )

    const taboolaMode =
        renditionType === 'app'
            ? 'alternating-thumbnails-a-app'
            : 'alternating-thumbnails-a'

    React.useEffect(() => {
        if (result === ScriptLoadResult.Success) {
            // TODO Fix type error here
            window._taboola.push({
                [locationType]: 'auto',
                url: window.location.href,
            } as any)

            window._taboola.push({
                mode: taboolaMode,
                container: taboolaContainerId,
                placement: `Below ${capitalize(locationType)} Thumbnails`,
                target_type: 'mix',
            })
        }
    }, [result, articleId, taboolaContainerId, locationType, taboolaMode])

    return <div id={taboolaContainerId} className={cx('hide-print')}></div>
}
Taboola.displayName = 'Taboola'

export default Taboola
